// extracted by mini-css-extract-plugin
module.exports = {"label":"LabelLink_label__1HiTY"};